import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { addMonths, isAfter, isBefore, MIN_REPRESENTABLE_DATE, startOfMonth, startOfToday, subMonths, } from '@repo/date-time';
import { useState } from 'react';
import MonthSelector from '../MonthSelector/MonthSelector';
import MonthCalendar from './MonthCalendar';
import MonthCalendarHeader from './MonthCalendarHeader';
export default function MonthCalendarNavigator({ initialDate, shownMonth: controlledShownMonth, onShownMonthChange, disablePast, minDate, maxDate, flaggedDates, selectionStart, selectionEnd, testId, onDateChosen, }) {
    const today = startOfToday();
    const [internalShownMonth, setInternalShownMonth] = useState(initialDate ?? today);
    const [isMonthSelectionVisible, setIsMonthSelectionVisible] = useState(false);
    const shownMonth = controlledShownMonth ?? internalShownMonth;
    const commitShownMonth = (next) => {
        if (onShownMonthChange)
            onShownMonthChange(next);
        else
            setInternalShownMonth(next);
    };
    const lowerBound = minDate ?? (disablePast ? today : new Date(MIN_REPRESENTABLE_DATE));
    const canGoPrev = isAfter(startOfMonth(shownMonth), startOfMonth(lowerBound));
    const canGoNext = isBefore(startOfMonth(shownMonth), startOfMonth(maxDate));
    const handleOpenMonthSelection = () => setIsMonthSelectionVisible(true);
    const handleMonthSelected = (newDate) => {
        commitShownMonth(newDate);
        setIsMonthSelectionVisible(false);
    };
    const handlePrevMonth = () => {
        if (canGoPrev)
            commitShownMonth(subMonths(shownMonth, 1));
    };
    const handleNextMonth = () => {
        if (canGoNext)
            commitShownMonth(addMonths(shownMonth, 1));
    };
    return (_jsxs("div", { className: "flex flex-col gap-3", children: [_jsx(MonthCalendarHeader, { shownMonth: shownMonth, canGoPrev: canGoPrev, canGoNext: canGoNext, testId: testId, onPrevMonth: handlePrevMonth, onNextMonth: handleNextMonth, onOpenMonthSelection: handleOpenMonthSelection }), isMonthSelectionVisible && (_jsx("div", { className: "z-overlay fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm", children: _jsx("div", { children: _jsx(MonthSelector, { date: shownMonth, onMonthSelected: handleMonthSelected, disablePast: disablePast, maxDate: maxDate, testId: testId.append('monthView') }) }) })), _jsx(MonthCalendar, { forDate: shownMonth, disablePast: disablePast, minDate: minDate, maxDate: maxDate, flaggedDates: flaggedDates, selectionStart: selectionStart, selectionEnd: selectionEnd, testId: testId.append('grid'), onDateChosen: onDateChosen })] }));
}
